
import { Badge } from "@/components/ui/badge";
import { Crown, Sparkles, Timer } from "lucide-react";
import { Product } from "@/types/common";
import { hasDiscount, getDiscountPercentage } from "@/utils/productTypeUtils";

interface PremiumProductBadgesProps {
  product: Product;
}

const PremiumProductBadges = ({ product }: PremiumProductBadgesProps) => {
  const productHasDiscount = hasDiscount(product);
  const discountPercentage = getDiscountPercentage(product);
  const isLowStock = product.stock_quantity !== null && product.stock_quantity <= 5;
  const isOutOfStock = product.stock_quantity === 0;
  const isNewArrival = new Date(product.created_at || '') > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);

  return (
    <div className="absolute top-4 left-4 z-20 flex flex-col gap-2">
      {product.featured && (
        <Badge className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-white border-0 shadow-lg">
          <Crown className="w-3 h-3 mr-1" />
          Premium
        </Badge>
      )}
      {isNewArrival && (
        <Badge className="bg-gradient-to-r from-emerald-500 to-teal-500 text-white border-0 shadow-lg">
          <Sparkles className="w-3 h-3 mr-1" />
          New
        </Badge>
      )}
      {productHasDiscount && (
        <Badge className="bg-gradient-to-r from-red-500 to-pink-500 text-white border-0 shadow-lg animate-pulse">
          -{discountPercentage}% OFF
        </Badge>
      )}
      {isLowStock && !isOutOfStock && (
        <Badge className="bg-gradient-to-r from-orange-500 to-red-500 text-white border-0 shadow-lg animate-pulse">
          <Timer className="w-3 h-3 mr-1" />
          Limited
        </Badge>
      )}
    </div>
  );
};

export default PremiumProductBadges;
